/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanFrameIcon32Regular = forwardRef('ScanFrameIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M29 8a5 5 0 0 0-5-5h-3a1 1 0 1 0 0 2h3a3 3 0 0 1 3 3v3a1 1 0 1 0 2 0V8Z" }),
        React.createElement("path", { d: "M8 29a5 5 0 0 1-5-5v-3a1 1 0 1 1 2 0v3a3 3 0 0 0 3 3h3a1 1 0 1 1 0 2H8Z" }),
        React.createElement("path", { d: "M24 29a5 5 0 0 0 5-5v-3a1 1 0 1 0-2 0v3a3 3 0 0 1-3 3h-3a1 1 0 1 0 0 2h3Z" }),
        React.createElement("path", { d: "M8 3a5 5 0 0 0-5 5v3a1 1 0 1 0 2 0V8a3 3 0 0 1 3-3h3a1 1 0 1 0 0-2H8Z" })));
});
